module.exports = __webpack_public_path__ + "static/img/oilApplication5.059ca6c3.png";